import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import AddHotTopicModal from "./AddHotTopicModal";
import TopicCard from "./TopicCard";
import "./index.css";

class HotTopic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      brand: "",
      role: "",
      loading: true,
      hotTopics: [],
      membersHotVideos: [],
      referralsHotVideos: [],
      umbrellaBrand: false,
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({
        username,
        role,
        brand,
        loading: true,
      });

      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (!brand_data) return;
        this.setState({
          logo: brand_data.logo,
          icon: brand_data.icon,
          territory: brand_data.territory,
          brand_name: brand_data.name,
          brand_url: brand_data.url,
          umbrellaBrand: brand_data.umbrella,
          hex: brand_data.hex,
          white: brand_data.white,
          is_property_brand: brand_data.is_property_brand
            ? brand_data.is_property_brand
            : false,
        });
        const { parent } = brand_data;
        Firebase.getAllHotTopics(brand_data.name, (hotTopics) => {
          if (parent) {
            // I am inside sub brand and wanna get parent articles
            Firebase.getBrandDataByID(parent, (parentBrand_Data) => {
              const parentBrandName = parentBrand_Data.name;
              Firebase.getAllHotTopics(parentBrandName, (parentTopics) => {
                this.setState({
                  hotTopics: [
                    ...hotTopics,
                    ...parentTopics.filter((p) => p.postToSub),
                  ],
                  loading: false,
                });
              });
            });
          } else this.setState({ hotTopics: hotTopics, loading: false });
        });
      });
    }
  }

  renderHotTopics = () => {
    const { hotTopics, brand_name, umbrellaBrand, hex, white } = this.state;
    const { myRole } = this.props;
    const umbrella = myRole === "isUmbrella" && umbrellaBrand;
    return (
      <div className="hotTopic-content">
        <div className="hotTopic-items">
          {hotTopics
            .filter((i) => (umbrella ? i.postToSub : true))
            .map((item, index) => (
              <Link
                to={{
                  pathname: `/hot-topic/${item.id}`,
                  state: {
                    brand_name: brand_name,
                    hex: hex,
                    white: white,
                  },
                }}
                key={index}
              >
                <TopicCard item={item} key={item.id} />
              </Link>
            ))}
          <button
            className="btn-secondary hotTopic-item add-hotTopic-btn btn-brand-hex btn-light"
            data-toggle="modal"
            data-target="#add_hotTopic_modal"
            style={{
              boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.2)",
              backgroundColor: "white",
              color: "black",
              "--hover-color": hex,
              "--hover-text-color": white ? "white" : "black",
            }}
          >
            <p style={{ fontSize: "65px", lineHeight: "65px" }}>+</p>
            <p className="hotTopic-item-text">Add a new hot topic</p>
          </button>
        </div>
      </div>
    );
  };

  createHotTopic = async (payload) => {
    const {
      media_type,
      media_url,
      title,
      description,
      starting_monday,
      toMembers,
      toReferrals,
    } = payload;

    const { myRole } = this.props;

    let { brand_name, hotTopics, umbrellaBrand } = this.state;
    this.setState({ loading: true });
    let hotTopic = {
      title,
      description,
      media_type,
      media_url,
      starting_monday,
      toMembers,
      toReferrals,
    };
    if (myRole === "isUmbrella" && umbrellaBrand) {
      hotTopic.postToSub = true;
    }
    Firebase.addHotTopic(hotTopic, brand_name).then((res) => {
      hotTopics.push({ ...hotTopic, id: res.id });
      this.setState({ loading: false, hotTopics });
    });
  };

  render() {
    const {
      username,
      role,
      loading,
      logo,
      brand,
      brand_name,
      is_property_brand,
      territory,
      hex,
      white,
    } = this.state;

    return (
      <div id="page-container" className="hotTopic-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          )}
          {!loading && (
            <Fragment>
              {this.renderHotTopics()}
              <AddHotTopicModal
                createHotTopic={this.createHotTopic}
                territory={territory}
                white={white}
                hex={hex}
              />
            </Fragment>
          )}
        </main>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    myRole: state.myRole,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(HotTopic);



// WEBPACK FOOTER //
// ./src/screens/HotTopic/index.js